import React from "react";

import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import MonitorIcon from "@mui/icons-material/Monitor";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";

export function IconService({ service }) {
    if (service === 700) {
        return <PhoneIphoneIcon style={{ marginLeft: "0.5rem" }} />;
    } else if (service === 666) {
        return <PhoneEnabledIcon style={{ marginLeft: "0.5rem" }} />;
    } else {
        return <MonitorIcon style={{ marginLeft: "0.5rem" }} />;
    }
}
